@if (tooltipText !== '') {
  <div class="border bg-white p-2 shadow-lg rounded fade-in text-sm" [ngClass]="['tooltip--'+position]">
    <ng-container [ngTemplateOutlet]="content ? content : text"></ng-container>
    <ng-template #text>{{tooltipText}}</ng-template>
  </div>
}
